module.exports = __webpack_public_path__ + "static/media/logo-espaco-bayer.0878067b.png";